<template>
  <div v-if="search" class="filter-wrapper mb-3 mb-md-0">
    <p>Fritext sök:</p>
    <span class="position-relative search-field-wrapper">
      <input type="text" v-model="searchInput" v-on:keyup="search" placeholder="Sök område, adress..." class="mb-1 mb-md-0">
    </span>
  </div>
</template>

<script>
module.exports = {
  data() {
    return {
      searchInput: '',
      name: 'search',
    };
  },
  props: {
    noItems: {
      type: Number,
      default: 0,
    },
  },
  computed: {
  },
  methods: {
    search() {
      this.setQueryParams();
      this.emitSearch();
    },
    emitSearch() {
      // Check if there is no items and if the search input contains a number. If the user has typed in Streetname 2
      // and there is no matching results the number should be removed so other objects on the same address will be displayed.
      if (this.noItems === 1 && this.searchInput.match(/[0-9]$/)) {
        // Remove number from search input.
        const newText = this.searchInput.replace(/[0-9]/g, '').trim();
        // Set the new value to the input field.
        this.searchInput = newText;
        this.setQueryParams();
      }

      //normalize data (data.name and data.value), make it reusable
      const data = {
        name: this.name,
        value: this.searchInput,
      };

      this.$emit('search-change', data); //emit event do parent (using $emit instead of fire to not make it global)
    },
    getQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has(this.name)) {
        const params = urlParams.get(this.name).split(',');
        params.forEach((param) => {
          if (param) {
            this.searchInput = param;
            this.emitSearch();
          }
        });
      }
    },
    setQueryParams() {
      let value = '';
      value = this.searchInput;
      const urlParams = new URLSearchParams(window.location.search);
      if (value == '') {
        urlParams.delete(this.name);
      } else {
        urlParams.set(this.name, value);
      }
      window.history.replaceState(null, null, '?' + urlParams.toString());
    },
  },
  created() {
    this.getQueryParams();
  },
  watch: {
    noItems: function () {
      // when the hash noItems prop changes, this function will be fired.
      this.emitSearch();
    }
  }
};
</script>
<style>
</style>
